import Vue from "vue";
import Router from "vue-router";
// import  { createRouter, createWebHistory  } from "vue-router"
// import NavMenu from "@/components/Navtab/navtab";
Vue.use(Router);
/* 公用首页---头部，导航栏 */
import test from "@/components/Test/test";
import register from "@/components/register/register"
import Siteall from "@/components/Siteall/Siteall"
import Login from "@/components/Login/Login"
import reset from "@/components/register/Reset"
import weus from "@/components/Weus/weus"
import mentorlist from "@/components/mentor/mentorlist"
import expertlist from "@/components/expert/expertlist"
import expertdetails from "@/components/expert/expert"
import traveler from "@/components/Traveler/Travelerlist"
import travelerdetails from "@/components/Traveler/Travelerdetails"
import Home from "@/components/Home/Home"
import Ntdetails from "@/components/Home/ntdetails"
import Newslist from "@/components/News/newslist"
import NewsDetails from "@/components/News/newsdetails" //文章详情
import Camplist from "@/components/Camp/camplist"
import Campmap from "@/components/Camp/campmap"
import Baselist from "@/components/Camp/homebaselist"
import CampDetails from "@/components/Camp/campdetails" //营地详情
import Linelist from "@/components/Line/linelist"
import LineDetails from "@/components/Line/linedetails"//路线详情
import BxbkLogin from "@/components/bxbkLogin/BxbkLogin"
import Bxbk from "@/components/bxbk/bxbk"
import Courselist from "@/components/Course/courselist"
import CourseDetails from "@/components/Course/coursedetails"
import Mobile from "../components/Mobile/Mobile.vue";
import Activitylist from "@/components/Activity/activitylist"
import Activitydetails from "@/components/Activity/activitydetails"
import Home1 from "../components/Home1/Home1.vue";
// export default new Router(
//     {
//          routes : [
//              {
//                  path: '/',  // 程序启动默认路由
//                  component: NavMenu,
//                  meta: {title: '整体页面布局'},
//                  redirect: '/Home',  // 重定向到首页
//                  children:[
//                      {
//                          path: '/Home',  // 程序启动默认路由
//                          component: Home,
//                          meta: {title: '首页'},

//                      },
//                  ]
//              },
//         ]
//     }
// )
// export default new Router({
	//定义路由
const  routers= [
    {
      path: '/',
      name: "/",
      component:Home
    },
	{
	  path: '/test',
	  name: "/test",
	  component:test
	},
	{
	  path: '/Mobile',
	  name: "/Mobile",
	  component:Mobile
	},
	{
	  path: '/Home1',
	  name: "/Home1",
	  component:Home1
	},
	{
		path: '/bxbkLogin',
		name: "/bxbkLogin",
		component:BxbkLogin
	  },
	  {
		path: '/bxbk',
		name: "/bxbk",
		component:Bxbk
	  },
	{
		path:'/Siteall',
		name:'/Siteall',
		component:Siteall
	},
	{
		path:'/register',
		name:'/register',
		component:register
	},
	{
		path: '/Login',
		name: "/Login",
		component:Login
	},
	{
		path:'/reset',
		name:"/reset",
		component:reset
	},
	{
		path:'/weus',
		name:"/weus",
		component:weus
	},
	{
		path: '/traveler',
		name: "/traveler",
		component:traveler
	},
	{
	  path: "/travelerdetails",
	  name: "travelerdetails",
	  component: travelerdetails,
	  meta: {
	    requireAuth: true,
	    path: "/travelerdetails",
	    name: "旅行商详情"
	  }
	},
	{
	  path: '/Home',
	  name: "/Home",
	  component:Home
	},
	{
	  path: '/mentorlist',
	  name: "/mentorlist",
	  component:mentorlist
	},
	{
		path:'/expertlist',
		name:'/expertlist',
		component:expertlist
	},
	{
		path:'/expertdetails',
		name:'expertdetails',
		component:expertdetails,
		meta:{
			requireAuth:true,
			path:'/expertdetails',
			name:'专家详情'
		}
	},
	{
	  path: '/Newslist',
	  name: "/Newslist",
	  component:Newslist
	},
	{
	  path: '/Camplist',
	  name: "/Camplist",
	  component:Camplist
	},
	{
	  path: '/Baselist',
	  name: "/Baselist",
	  component:Baselist
	},
	{
		path:'/Campmap',
		name:'/Campmap',
		component:Campmap
	},
	{
	  path: '/Linelist',
	  name: "/Linelist",
	  component:Linelist
	},
	{
	  path: '/Courselist',
	  name: "/Courselist",
	  component:Courselist
	},
	{
	  path: '/Activitylist',
	  name: "/Activitylist",
	  component:Activitylist
	},
	{
	  path: "/Ntdetails",
	  name: "Ntdetails",
	  component: Ntdetails,
	  meta: {
	    requireAuth: true,
	    path: "/Ntdetails",
	    name: "公告详情"
	  }
	},
	{
	  path: "/NewsDetails",
	  name: "NewsDetails",
	  component: NewsDetails,
	  meta: {
	    requireAuth: true,
	    path: "/Newslist",
	    name: "资讯详情"
	  }
	},
	{
	  path: "/CourseDetails",
	  name: "CourseDetails",
	  component: CourseDetails,
	  meta: {
	    requireAuth: true,
	    path: "/Courselist",
	    name: "课程详情"
	  }
	},
	{
	  path: "/CampDetails",
	  name: "CampDetails",
	  component: CampDetails,
	  meta: {
	    requireAuth: true,
	    path: "/Camplist",
	    name: "营地详情"
	  }
	},
	{
	  path: "/LineDetails",
	  name: "LineDetails",
	  component: LineDetails,
	  meta: {
	    requireAuth: true,
	    path: "/Linelist",
	    name: "路线详情"
	  }
	},
	{
	  path: "/Activitydetails",
	  name: "Activitydetails",
	  component: Activitydetails,
	  meta: {
	    requireAuth: true,
	    path: "/Activitylist",
	    name: "活动详情"
	  }
	},
	
  ]
  
// })

// 创建router实例
// const router = createRouter({
//     history: createWebHistory(),
//     routes:routers
// })
 
  
 const router = new Router({
//    mode: 'history',
   // base: process.env.BASE_URL,
   routes:routers
 })
// 导出router实例
export default router


// const router = new Router({
//   mode: "history",
//   routes: [
//     {
//       path: "/",
//       name: "Home",
//       component: Home
//     },
// 	],
// });
// export default router;

// router.beforeEach((to, form, next) => {
//   if (to.meta.requireAuth) {
//     if (localStorage.getItem("token")) {
//       axios.defaults.headers["X-Access-Token"] = localStorage.getItem("token");
//       next();
//     } else {
//       next({
//         path: "/"
//       });
//     }
//   } else {
//     next();
//   }
// });